export const defaultPairs =

    [
        {
            "entityID": "AGGY",
            "entityMappedID": "AGG"
        },
        {
            "entityID": "AGGY",
            "entityMappedID": "BND"
        },
        {
            "entityID": "AGGY",
            "entityMappedID": "BOND"
        },
        {
            "entityID": "AGGY",
            "entityMappedID": "TOTL"
        },
        {
            "entityID": "AGZD",
            "entityMappedID": "IGHG"
        },
        {
            "entityID": "AGZD",
            "entityMappedID": "LQDH"
        },
        {
            "entityID": "CEW",
            "entityMappedID": "UDN"
        },
        {
            "entityID": "CEW",
            "entityMappedID": "UUP"
        },
        {
            "entityID": "CXSE",
            "entityMappedID": "GXC"
        },
        {
            "entityID": "CXSE",
            "entityMappedID": "FXI"
        },
        {
            "entityID": "CXSE",
            "entityMappedID": "MCHI"
        },
        {
            "entityID": "DDLS",
            "entityMappedID": "DLS"
        },
        {
            "entityID": "DDLS",
            "entityMappedID": "DISVX"
        },
        {
            "entityID": "DDLS",
            "entityMappedID": "SCZ"
        },
        {
            "entityID": "DDWM",
            "entityMappedID": "PXF"
        },
        {
            "entityID": "DDWM",
            "entityMappedID": "DEFA"
        },
        {
            "entityID": "DDWM",
            "entityMappedID": "IEFA"
        },
        {
            "entityID": "DEM",
            "entityMappedID": "PXH"
        },
        {
            "entityID": "DEM",
            "entityMappedID": "DFEVX"
        },
        {
            "entityID": "DEM",
            "entityMappedID": "DVYE"
        },
        {
            "entityID": "DEM",
            "entityMappedID": "EDIV"
        },
        {
            "entityID": "DEM",
            "entityMappedID": "IEMG"
        },
        {
            "entityID": "DES",
            "entityMappedID": "DGRS"
        },
        {
            "entityID": "DES",
            "entityMappedID": "IJS"
        },
        {
            "entityID": "DES",
            "entityMappedID": "IWN"
        },
        {
            "entityID": "DEW",
            "entityMappedID": "ACWI"
        },
        {
            "entityID": "DEW",
            "entityMappedID": "VT"
        },
        {
            "entityID": "DFE",
            "entityMappedID": "VGK"
        },
        {
            "entityID": "DFJ",
            "entityMappedID": "EWJ"
        },
        {
            "entityID": "DFJ",
            "entityMappedID": "SCJ"
        },
        {
            "entityID": "DGRE",
            "entityMappedID": "EEM"
        },
        {
            "entityID": "DGRE",
            "entityMappedID": "GEM"
        },
        {
            "entityID": "DGRE",
            "entityMappedID": "PXF"
        },
        {
            "entityID": "DGRE",
            "entityMappedID": "VWO"
        },
        {
            "entityID": "DGRS",
            "entityMappedID": "DES"
        },
        {
            "entityID": "DGRS",
            "entityMappedID": "IJR"
        },
        {
            "entityID": "DGRS",
            "entityMappedID": "IJS"
        },
        {
            "entityID": "DGRW",
            "entityMappedID": "VIG"
        },
        {
            "entityID": "DGRW",
            "entityMappedID": "SPY"
        },
        {
            "entityID": "DGS",
            "entityMappedID": "EEM"
        },
        {
            "entityID": "DGS",
            "entityMappedID": "EEMS"
        },
        {
            "entityID": "DHS",
            "entityMappedID": "DFLVX"
        },
        {
            "entityID": "DHS",
            "entityMappedID": "DVY"
        },
        {
            "entityID": "DHS",
            "entityMappedID": "IWD"
        },
        {
            "entityID": "DIM",
            "entityMappedID": "DISVX"
        },
        {
            "entityID": "DIM",
            "entityMappedID": "SCZ"
        },
        {
            "entityID": "DLN",
            "entityMappedID": "DFLVX"
        },
        {
            "entityID": "DLN",
            "entityMappedID": "DVY"
        },
        {
            "entityID": "DLN",
            "entityMappedID": "IWD"
        },
        {
            "entityID": "DLN",
            "entityMappedID": "VTV"
        },
        {
            "entityID": "DLS",
            "entityMappedID": "DISVX"
        },
        {
            "entityID": "DLS",
            "entityMappedID": "SCZ"
        },
        {
            "entityID": "DNL",
            "entityMappedID": "IQDG"
        },
        {
            "entityID": "DNL",
            "entityMappedID": "VXUS"
        },
        {
            "entityID": "DOL",
            "entityMappedID": "EFV"
        },
        {
            "entityID": "DOL",
            "entityMappedID": "PXF"
        },
        {
            "entityID": "DOL",
            "entityMappedID": "EFA"
        },
        {
            "entityID": "DON",
            "entityMappedID": "DVY"
        },
        {
            "entityID": "DON",
            "entityMappedID": "IWS"
        },
        {
            "entityID": "DOO",
            "entityMappedID": "EFV"
        },
        {
            "entityID": "DOO",
            "entityMappedID": "EFAV"
        },
        {
            "entityID": "DRW",
            "entityMappedID": "VNQ"
        },
        {
            "entityID": "DRW",
            "entityMappedID": "ACWI"
        },
        {
            "entityID": "DRW",
            "entityMappedID": "IXUS"
        },
        {
            "entityID": "DTD",
            "entityMappedID": "DFLVX"
        },
        {
            "entityID": "DTD",
            "entityMappedID": "DVY"
        },
        {
            "entityID": "DTD",
            "entityMappedID": "IWD"
        },
        {
            "entityID": "DTD",
            "entityMappedID": "VTV"
        },
        {
            "entityID": "DTH",
            "entityMappedID": "EFV"
        },
        {
            "entityID": "DTH",
            "entityMappedID": "PXF"
        },
        {
            "entityID": "DTN",
            "entityMappedID": "DFLVX"
        },
        {
            "entityID": "DTN",
            "entityMappedID": "DVY"
        },
        {
            "entityID": "DTN",
            "entityMappedID": "IWD"
        },
        {
            "entityID": "DWM",
            "entityMappedID": "EFV"
        },
        {
            "entityID": "DWM",
            "entityMappedID": "PXF"
        },
        {
            "entityID": "DWM",
            "entityMappedID": "DBEF"
        },
        {
            "entityID": "DWM",
            "entityMappedID": "EFAV"
        },
        {
            "entityID": "DWMF",
            "entityMappedID": "QICLX"
        },
        {
            "entityID": "DWMF",
            "entityMappedID": "GSIE"
        },
        {
            "entityID": "DWMF",
            "entityMappedID": "INTF"
        },
        {
            "entityID": "DWMF",
            "entityMappedID": "JHMD"
        },
        {
            "entityID": "DWMF",
            "entityMappedID": "JPIN"
        },
        {
            "entityID": "DXGE",
            "entityMappedID": "DBEU"
        },
        {
            "entityID": "DXGE",
            "entityMappedID": "EZU"
        },
        {
            "entityID": "DXGE",
            "entityMappedID": "HEZU"
        },
        {
            "entityID": "DXGE",
            "entityMappedID": "EWG"
        },
        {
            "entityID": "DXJ",
            "entityMappedID": "EWJ"
        },
        {
            "entityID": "DXJ",
            "entityMappedID": "HEWJ"
        },
        {
            "entityID": "DXJS",
            "entityMappedID": "SCJ"
        },
        {
            "entityID": "DXJS",
            "entityMappedID": "DFJ"
        },
        {
            "entityID": "EES",
            "entityMappedID": "IJS"
        },
        {
            "entityID": "EES",
            "entityMappedID": "VBR"
        },
        {
            "entityID": "EES",
            "entityMappedID": "IWN"
        },
        {
            "entityID": "ELD",
            "entityMappedID": "EBND"
        },
        {
            "entityID": "ELD",
            "entityMappedID": "EMLC"
        },
        {
            "entityID": "ELD",
            "entityMappedID": "LEMB"
        },
        {
            "entityID": "EMCB",
            "entityMappedID": "EMB"
        },
        {
            "entityID": "EMCB",
            "entityMappedID": "JPMB"
        },
        {
            "entityID": "EMCB",
            "entityMappedID": "PCY"
        },
        {
            "entityID": "EMMF",
            "entityMappedID": "EEMV"
        },
        {
            "entityID": "EMMF",
            "entityMappedID": "EMGF"
        },
        {
            "entityID": "EMMF",
            "entityMappedID": "GEM"
        },
        {
            "entityID": "EMMF",
            "entityMappedID": "JHEM"
        },
        {
            "entityID": "EMMF",
            "entityMappedID": "JPEM"
        },
        {
            "entityID": "EPI",
            "entityMappedID": "INDA"
        },
        {
            "entityID": "EPI",
            "entityMappedID": "INDY"
        },
        {
            "entityID": "EPS",
            "entityMappedID": "PRF"
        },
        {
            "entityID": "EPS",
            "entityMappedID": "SPY"
        },
        {
            "entityID": "EPS",
            "entityMappedID": "IWD"
        },
        {
            "entityID": "EUDG",
            "entityMappedID": "EZU"
        },
        {
            "entityID": "EUDG",
            "entityMappedID": "VGK"
        },
        {
            "entityID": "EUSC",
            "entityMappedID": "VGK"
        },
        {
            "entityID": "EUSC",
            "entityMappedID": "DFE"
        },
        {
            "entityID": "EZM",
            "entityMappedID": "IJJ"
        },
        {
            "entityID": "EZM",
            "entityMappedID": "IWS"
        },
        {
            "entityID": "EZM",
            "entityMappedID": "MDY"
        },
        {
            "entityID": "GCC",
            "entityMappedID": "PDBC"
        },
        {
            "entityID": "GCC",
            "entityMappedID": "DBC"
        },
        {
            "entityID": "GCC",
            "entityMappedID": "GLD"
        },
        {
            "entityID": "HEDJ",
            "entityMappedID": "DBEU"
        },
        {
            "entityID": "HEDJ",
            "entityMappedID": "EZU"
        },
        {
            "entityID": "HEDJ",
            "entityMappedID": "HEZU"
        },
        {
            "entityID": "HEDJ",
            "entityMappedID": "VGK"
        },
        {
            "entityID": "HYZD",
            "entityMappedID": "BKLN"
        },
        {
            "entityID": "HYZD",
            "entityMappedID": "HYGH"
        },
        {
            "entityID": "HYZD",
            "entityMappedID": "HYHG"
        },
        {
            "entityID": "HYZD",
            "entityMappedID": "SNLN"
        },
        {
            "entityID": "HYZD",
            "entityMappedID": "SRLN"
        },
        {
            "entityID": "IHDG",
            "entityMappedID": "DBEF"
        },
        {
            "entityID": "IHDG",
            "entityMappedID": "EFA"
        },
        {
            "entityID": "IHDG",
            "entityMappedID": "EFAV"
        },
        {
            "entityID": "IHDG",
            "entityMappedID": "HEFA"
        },
        {
            "entityID": "ihdg",
            "entityMappedID": "IQDG"
        },
        {
            "entityID": "IQDG",
            "entityMappedID": "DFIVX"
        },
        {
            "entityID": "IQDG",
            "entityMappedID": "EFA"
        },
        {
            "entityID": "IQDG",
            "entityMappedID": "EFAV"
        },
        {
            "entityID": "IXSE",
            "entityMappedID": "EPI"
        },
        {
            "entityID": "IXSE",
            "entityMappedID": "INDA"
        },
        {
            "entityID": "IXSE",
            "entityMappedID": "INDY"
        },
        {
            "entityID": "NTSX",
            "entityMappedID": "SPY"
        },
        {
            "entityID": "NTSX",
            "entityMappedID": "VBINX"
        },
        {
            "entityID": "NTSX",
            "entityMappedID": "PXTIX"
        },
        {
            "entityID": "NTSX",
            "entityMappedID": "DSEEX"
        },
        {
            "entityID": "PLAT",
            "entityMappedID": "QQQ"
        },
        {
            "entityID": "PLAT",
            "entityMappedID": "VUG"
        },
        {
            "entityID": "PLAT",
            "entityMappedID": "XLK"
        },
        {
            "entityID": "PLAT",
            "entityMappedID": "IWF"
        },
        {
            "entityID": "PUTW",
            "entityMappedID": "PBP"
        },
        {
            "entityID": "QSY",
            "entityMappedID": "IWD"
        },
        {
            "entityID": "QSY",
            "entityMappedID": "SDY"
        },
        {
            "entityID": "RESD",
            "entityMappedID": "EFA"
        },
        {
            "entityID": "RESD",
            "entityMappedID": "ESGD"
        },
        {
            "entityID": "RESE",
            "entityMappedID": "ESGE"
        },
        {
            "entityID": "RESE",
            "entityMappedID": "IEMG"
        },
        {
            "entityID": "RESP",
            "entityMappedID": "ESGU"
        },
        {
            "entityID": "RESP",
            "entityMappedID": "ESGV"
        },
        {
            "entityID": "RESP",
            "entityMappedID": "IVV"
        },
        {
            "entityID": "RESP",
            "entityMappedID": "SPY"
        },
        {
            "entityID": "RESP",
            "entityMappedID": "SUSL"
        },
        {
            "entityID": "SFHY",
            "entityMappedID": "HYS"
        },
        {
            "entityID": "SFHY",
            "entityMappedID": "SHYG"
        },
        {
            "entityID": "SFHY",
            "entityMappedID": "SJNK"
        },
        {
            "entityID": "SFIG",
            "entityMappedID": "SLQD"
        },
        {
            "entityID": "SFIG",
            "entityMappedID": "SPSB"
        },
        {
            "entityID": "SFIG",
            "entityMappedID": "VCSH"
        },
        {
            "entityID": "SHAG",
            "entityMappedID": "BSV"
        },
        {
            "entityID": "USDU",
            "entityMappedID": "UUP"
        },
        {
            "entityID": "USFR",
            "entityMappedID": "BIL"
        },
        {
            "entityID": "USFR",
            "entityMappedID": "FLOT"
        },
        {
            "entityID": "USFR",
            "entityMappedID": "FLRN"
        },
        {
            "entityID": "USMF",
            "entityMappedID": "RSP"
        },
        {
            "entityID": "USMF",
            "entityMappedID": "LRGF"
        },
        {
            "entityID": "USMF",
            "entityMappedID": "USMV"
        },
        {
            "entityID": "WCLD",
            "entityMappedID": "CLOU"
        },
        {
            "entityID": "WCLD",
            "entityMappedID": "QQQ"
        },
        {
            "entityID": "WCLD",
            "entityMappedID": "SKYY"
        },
        {
            "entityID": "WCLD",
            "entityMappedID": "VGT"
        },
        {
            "entityID": "WFHY",
            "entityMappedID": "HYG"
        },
        {
            "entityID": "WFHY",
            "entityMappedID": "PHB"
        },
        {
            "entityID": "WFHY",
            "entityMappedID": "USHY"
        },
        {
            "entityID": "WFIG",
            "entityMappedID": "IGIB"
        },
        {
            "entityID": "WFIG",
            "entityMappedID": "LQD"
        },
        {
            "entityID": "XSOE",
            "entityMappedID": "EEM"
        },
        {
            "entityID": "XSOE",
            "entityMappedID": "VWO"
        }
    ]
